import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45180ff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-auto col-md-auto col-sm-auto col-xs-12 card bg-blue item-font text-white" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto product-quote-padding pe-0" }, "Your quote per", -1))
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "middle-border" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-8 col-md-8 col-sm-8 col-xs-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-end item-body item-bold text-white" }, " Notes:", -1))
const _hoisted_12 = { class: "text-align item-content text-white pb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "item-body item-bold" }
const _hoisted_15 = { class: "item-main-title item-booster-blue pb-0 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_QuoteSection = _resolveComponent("QuoteSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isMobileScreen ? 'pt-3 pb-3' : 'p-0 card-body')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["item-secondary-title text-white pt-1 pb-0 mb-0", _ctx.isMobileScreen ? 'ms-0 px-3' : 'm-2 p-2'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SelectInput, {
              value: _ctx.frequency,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frequency) = $event)),
              options: _ctx.frequencies,
              class: "quote-card-select-input"
            }, null, 8, ["value", "options"])
          ])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.existingProductsExist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_QuoteSection, {
                "product-title": "Insurance product",
                "cover-amount-title": "Cover amount",
                "premium-amount-title": `${_ctx.frequencyWithProperCase} cost`,
                "is-mobile-screen": _ctx.isMobileScreen,
                items: _ctx.productsItems,
                frequency: _ctx.frequency
              }, null, 8, ["premium-amount-title", "is-mobile-screen", "items", "frequency"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.existingProductsExist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_QuoteSection, {
                "product-title": "Existing cover",
                "cover-amount-title": "Existing cover amount",
                "premium-amount-title": `Existing ${_ctx.frequency} premium`,
                "is-mobile-screen": _ctx.isMobileScreen,
                items: _ctx.existingProductsItems,
                frequency: _ctx.frequency
              }, null, 8, ["premium-amount-title", "is-mobile-screen", "items", "frequency"]),
              _createVNode(_component_QuoteSection, {
                "product-title": "Added cover",
                "cover-amount-title": "Added cover amount",
                "premium-amount-title": `Added ${_ctx.frequency} premium`,
                "is-mobile-screen": _ctx.isMobileScreen,
                items: _ctx.productsItems,
                frequency: _ctx.frequency,
                "is-dark-blue": ""
              }, null, 8, ["premium-amount-title", "is-mobile-screen", "items", "frequency"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["item-secondary-title text-white", _ctx.isMobileScreen ? 'ms-0 p-3' : 'm-2 mb-0 p-2'])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showNotes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.notesText) + " ", 1),
                    _hoisted_13,
                    _createTextVNode(" If eligible, special events increases and Inflationary increases do not require new underwriting but are subject to this limit. ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-lg-4 col-md-4 col-sm-4 col-xs-12", {'pb-2': !_ctx.showNotes}])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["p-2", _ctx.isMobileScreen ? 'card-total-payment-sm' : 'card-total-payment m-2'])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_14, "Total " + _toDisplayString(_ctx.frequency) + " payment", 1),
                _createElementVNode("div", _hoisted_15, "$" + _toDisplayString(_ctx.premiumAmount), 1)
              ])
            ], 2)
          ], 2)
        ])
      ], 2)
    ], 2)
  ]))
}